
    import Vue from "vue";

    const END_POINT = "/classroom";

    const getClassroom = id => Vue.axios.get(END_POINT + "/" + id);

    const getAllClassrooms = data => Vue.axios.get(END_POINT, {params: data});

    const createClassroom = classroom => Vue.axios.post(END_POINT,  classroom );

    const createAllClassrooms = Classrooms => Vue.axios.post(END_POINT + "/all",  Classrooms );

    const updateClassroom = classroom => Vue.axios.put(END_POINT  + "/" + classroom.id,  classroom );

    const deleteClassroom = id => Vue.axios.delete(END_POINT  + "/" + id);

    export {
      getClassroom,
      getAllClassrooms,
      createClassroom,
      createAllClassrooms,
      updateClassroom,
      deleteClassroom
    };
    